import { AVAILABILITY_CONSTANTS } from "@/modules/Availability/constants/AvailabilityConstants";
import { CupsPriceLevelService } from "@/modules/CupsPriceLevels/services/CupsPriceLevelService";
import { LACK_OF_OPTIONS } from "@/modules/Dashboards/AdminDashboard/constants/AdminDashboardConstants";
import { FormTemplateService } from "@/modules/FormTemplate/services/FormTemplateService";
import { ListService } from "@/modules/List/services/ListService";
import { SpaceService } from "@/modules/Space/services/SpaceService";
import { CampusService } from "@/modules/Campus/services/CampusService";
import { RolesService } from "@/modules/Roles/services/RolesService";
import { ServiceTemplateService } from "@/modules/ServiceTemplate/services/ServiceTemplateService";
import { SessionTemplateService } from "@/modules/SessionTemplate/services/SessionTemplateService";
import { UserService } from "@/modules/User/services/UserService";
import { UserTemplateService } from "@/modules/UserTemplate/services/UserTemplateService";
import { List } from "@/shared/components/GenericSearchBar/model/List";
import Snackbar from "@/shared/components/Snackbar/Snackbar";
import { FORM_MESSAGES } from "@/shared/constants/FormConstants";
import { STYLE_CLASSES } from "@/shared/constants/StyleConstants";
import { Http } from "@status/codes";
import { Component, Inject, Prop, Vue, Watch } from "vue-property-decorator";
import {
  BETWEEN_OPERATOR,
  FILTERS_NAMES_CONST,
  GENERAL_RULES_CONSTANTS,
  ID_LIST,
  INPUT_TYPE,
  PRICE_LEVEL,
  QUERY_USER_SERVICE,
  TIME_RELATED_FILTERS,
  TIME_UNITS,
  ESCHEMA_TYPES,
  LEVELS_GROUPS_STATES,
  SESION_STATUS_VALUES
} from "../../constants/GeneralRulesConstants";
import { DependenciesService } from "@/modules/Dependencies/services/DependenciesService";
import { QuerySend, QuerySendMultiple } from "@/shared/models/FormQuerySend";

import Vuetify from "vuetify";
import { GENERAL_CONSTANTS, STATE } from "@/shared/constants/GeneralConstants";
import { UserQuery } from "@/modules/User/models/UserQuery";
import { PreventKey } from "@/shared/mixins/mixins";
import { AxiosError } from "axios";
import { SERVICE_TEMPLATES_ACCESS } from "@/modules/ServiceTemplate/constants/ServiceTemplateConstants";
import { DEPENDENCIES_ACCESS } from "@/modules/Dependencies/constants/DependenciesConstants";
import {
  LIST_ACCESS,
  LIST_CONSTANTS
} from "@/modules/List/constants/ListConstants";
import { CUPS_ACCESS } from "@/modules/CupsPriceLevels/constants/CupsPriceLevelConstants";
import { SESSION_TEMPLATES_ACCESS } from "@/modules/SessionTemplate/constants/SessionTemplateConstants";
import { FORM_TEMPLATES_ACCESS } from "@/modules/FormTemplate/constants/FormTemplateConstants";
import { ROLES_ACCESS } from "@/modules/Roles/constants/RoleConstants";
import { USER_TEMPLATES_ACCESS } from "@/modules/UserTemplate/constants/UserTemplateConstants";
import { USER_ACCESS } from "@/modules/User/constants/UserConstants";
import DynamicSelect from "@/shared/components/DynamicSelect/DynamicSelect.vue";
import { DynamicSelectConfig } from "@/shared/components/DynamicSelect/model/DynamicSelectConfig";
import { DynamicSelectData } from "@/shared/components/DynamicSelect/model/DynamicSelectData";
import { FormStatus } from "@/modules/FormTemplate/models/FormStatus";
import { GenaralRuleField } from "../../models/GenaralRuleField.model";
import { Collection } from "../../models/Collection.model";
import lodash from "lodash";
import { ServiceTemplateHeader } from "@/modules/ServiceTemplate/models/ServiceTemplateHeader";
import store from "@/store";
import { mapGetters } from "vuex";
import _ from "lodash";
import { SpaceQuery } from "@/modules/Space/models/SpaceQuery";

Vue.use(Vuetify);
@Component({
  name: "Display",
  components: {
    DynamicSelect
  },
  computed: {
    ...mapGetters({
      groupsLevels: "getGroupsLevels"
    })
  }
})
export default class Display extends PreventKey {
  @Inject() serviceTemplateService!: ServiceTemplateService;
  @Inject() listService!: ListService;
  @Inject() spaceService!: SpaceService;
  @Inject() campusService!: CampusService;
  @Inject() cupsPriceLevelService!: CupsPriceLevelService;
  @Inject() sessionTemplateService!: SessionTemplateService;
  @Inject() formTemplateService!: FormTemplateService;
  @Inject() rolesService!: RolesService;
  @Inject() userTemplateService!: UserTemplateService;
  @Inject() userService!: UserService;
  @Inject() dependenciesService!: DependenciesService;

  @Prop() inputType!: string;
  @Prop() collection!: string;
  @Prop() field!: string;
  @Prop() operator!: string;
  @Prop() index!: string;
  @Prop() valueToEdit!: any;
  @Prop() editCase!: boolean;
  @Prop() cups: any;
  @Prop() cupsSelected!: List[];
  @Prop() userList?: any;
  @Prop() UsersListEnable!: any;
  @Prop() rule!: {};
  @Prop() indexOperatorChanged!: string;
  @Prop() operatorChanged!: boolean;
  @Prop({ default: "" }) timeUnitProp?: string;
  @Prop() conditionsContext!: any;

  save = false;
  textFieldClass = STYLE_CLASSES.TEXT_FIELD;
  BETWEEN_OPERATOR = BETWEEN_OPERATOR.operator;
  list: List[] = [];
  listNames: Array<string> = [];
  value: any = "";
  basicClass = STYLE_CLASSES.BASIC_PRIMARY;
  accentColor = STYLE_CLASSES.CHIP_COLOR.ACCENT;
  LOCALE = AVAILABILITY_CONSTANTS.CONFIGURATIONS.LOCALE;
  GENERAL_RULES_CONSTANTS = GENERAL_RULES_CONSTANTS;
  INPUT_TYPE = INPUT_TYPE;
  date: string[] | string = "";
  menu = false;
  modal = false;
  nowDate = new Date().toISOString().slice(0, 10);
  roundBtnClass = STYLE_CLASSES.TERTIARY_ROUND_BTN;
  user = "";
  timeUnitList = TIME_UNITS;
  TIME_BETWEEN_SESSIONS = FILTERS_NAMES_CONST.SESSION.FIELDS.TIME_BETWEEN;
  TIME_ELAPSED = FILTERS_NAMES_CONST.TIME_ELAPSED;
  TIME_RELATED_FILETRS = TIME_RELATED_FILTERS;
  timeUnit = "";
  vSelectClass = STYLE_CLASSES.FLEX_NOWRAP;
  SELECTED = GENERAL_RULES_CONSTANTS.SELECTED;
  status = false;
  FieldListModel = [] as DynamicSelectData[];
  FieldSelectConfig: DynamicSelectConfig = {
    multiple:
      this.operator == GENERAL_RULES_CONSTANTS.INCLUDE_OPERATOR ||
      this.operator == GENERAL_RULES_CONSTANTS.BELONGS_OPERATOR
        ? true
        : false,
    default: [],
    chips: true,
    notFound: false,
    listAll: [],
    filled: false,
    messageLabel: "",
    hideDetails: false
  };
  lastRef = "";
  keyword = "";
  dependency: string[] = [];
  lasRefWithNameFilter = "";
  serviceTemplates: ServiceTemplateHeader[] = [];
  groups: { key: string; name: string }[] = [];
  groupsLevels!: any[];

  async mounted() {
    if (this.timeUnitProp) this.timeUnit = this.timeUnitProp;
    await this.initializeSelects();
    this.operatorValidation();
  }
  get selectField() {
    return this.FieldListModel[0].id;
  }

  set selectField(value: string | number | boolean | Array<object>) {
    const findAndFormatOption = (
      id: string | number | boolean | object | unknown
    ) => {
      const option = this.FieldSelectConfig.listAll.find(
        item => item.id === id
      );
      return {
        id: option?.id ?? "",
        name: option?.name ?? ""
      };
    };

    if (
      typeof value === ESCHEMA_TYPES.STRING ||
      typeof value === ESCHEMA_TYPES.NUMBER ||
      typeof value === ESCHEMA_TYPES.BOOLEAN
    ) {
      this.FieldListModel = [findAndFormatOption(value)];
    } else if (Array.isArray(value)) {
      this.FieldListModel = value.map((item: any) =>
        findAndFormatOption(item.key != undefined ? item.key : item)
      );
    } else if (typeof value === ESCHEMA_TYPES.OBJECT) {
      const valueAsObj = value as { key?: unknown };
      this.FieldListModel = [findAndFormatOption(valueAsObj.key ?? value)];
    }
  }

  @Watch("FieldListModel")
  listenFieldListModel() {
    if (
      this.collection === "Servicio" &&
      this.field === FILTERS_NAMES_CONST.SERVICE.FIELDS.SERVICE_TEMPLATE.name
    ) {
      this.searchGroups(this.FieldListModel);
    }

    this.value = this.FieldListModel.map(item => {
      return { key: item.id, name: item.name };
    });
  }
  searchGroups(FieldListModel: DynamicSelectData[]) {
    this.groups = [];
    if (FieldListModel.length > 0) {
      FieldListModel.forEach(serviceTemplate => {
        const servicetemplate = this.serviceTemplates.find(
          item => item.id === serviceTemplate.id
        );
        if (servicetemplate && servicetemplate.groups) {
          this.groups = this.groups.concat(
            servicetemplate.groups.map(group => {
              group.key = group.key + "-" + servicetemplate.id;
              return group;
            })
          );
        }
      });
    }
    this.groups = this.groups.filter(
      (value, index, self) =>
        index === self.findIndex(t => t.name === value.name)
    );

    store.commit("setGroupsLevels", this.groups);
  }

  @Watch("operatorChanged")
  listenOperator() {
    if (this.indexOperatorChanged == this.index) {
      this.FieldSelectConfig.multiple =
        this.operator == GENERAL_RULES_CONSTANTS.INCLUDE_OPERATOR ||
        this.operator == GENERAL_RULES_CONSTANTS.BELONGS_OPERATOR
          ? true
          : false;
      this.value = "";
      this.FieldListModel = [];
      this.operatorValidation();
    }
  }

  operatorValidation() {
    this.date = this.operator === BETWEEN_OPERATOR.operator ? [] : "";
  }

  async initializeSelects() {
    if (this.inputType === INPUT_TYPE.SELECT) {
      const data = { type: this.collection, key: this.field };
      await this.getDataToSelect(data);
    } else {
      if (this.inputType === INPUT_TYPE.TEXT) {
        this.value = this.valueToEdit;
        this.setList(this.userList[this.index]);
      } else if (this.inputType === INPUT_TYPE.NUMBER) {
        this.value = this.valueToEdit;
      } else if (this.inputType === INPUT_TYPE.DATE_PICKER) {
        if (Array.isArray(this.valueToEdit)) {
          this.value = this.valueToEdit.map(value => this.formatDate(value));
        } else {
          this.value = this.formatDate(this.valueToEdit);
        }
      } else {
        this.preloadInput();
      }
    }
  }

  formatDate(date: string) {
    if (!date) return null;
    const [day, month, year] = date.split("-");
    return `${year}-${month}-${day}`;
  }

  @Watch("rule")
  listenChangeRule() {
    this.list = [];
    this.initializeSelects();
  }

  async getServiceTemplates() {
    try {
      let state;

      if (!this.editCase) {
        state = STATE.ACTIVE;
      }

      const response = await this.serviceTemplateService.getAllActiveServiceTemplate(
        state
      );

      if (response.code === Http.Found && response.data) {
        this.serviceTemplates = response.data;
        const serviceTemplatesList: List[] = [];
        this.$emit(
          GENERAL_RULES_CONSTANTS.EMITTERS.SERVICE_TEMPLATES,
          this.serviceTemplates
        );
        this.serviceTemplates.forEach(({ id, internalName }) => {
          serviceTemplatesList.push({
            key: id as string,
            name: internalName
          });
        });
        this.setList(serviceTemplatesList);
        this.selectField = this.valueToEdit;
      } else {
        Snackbar.popInfo(response.message);
      }
    } catch (error) {
      if ((error as AxiosError).response?.status == Http.Forbidden)
        Snackbar.popError(
          FORM_MESSAGES.FORBIDDEN_REQUEST + SERVICE_TEMPLATES_ACCESS.GET
        );
      else Snackbar.popError(FORM_MESSAGES.REQUEST_FAILED);
    }
  }

  setList(list: List[]) {
    this.list = list;
    this.FieldSelectConfig.listAll = _.cloneDeep(this.list).map(item => {
      return { id: item.key, name: item.name };
    });

    if (this.inputType !== INPUT_TYPE.TEXT) {
      this.preloadInput();
    }
  }

  async getDataToSelect(data: { type: string; key: string }) {
    const getData: {
      [list: string]: { [x: string]: () => Promise<void> };
    } = {
      [FILTERS_NAMES_CONST.SERVICE.NAME]: {
        [FILTERS_NAMES_CONST.SERVICE.FIELDS.USER.name]: async () => {
          await this.getUserByQuery(QUERY_USER_SERVICE.USER);
        },
        [FILTERS_NAMES_CONST.SERVICE.FIELDS.GROUP_LEVEL.name]: async () => {
          this.getGroupLevel();
        },
        [FILTERS_NAMES_CONST.SERVICE.FIELDS.STATE_GROUP_LEVEL
          .name]: async () => {
          this.getGroupLevelState();
        },
        [FILTERS_NAMES_CONST.SERVICE.FIELDS.SERVICE_TEMPLATE
          .name]: async () => {
          await this.getServiceTemplates();
        },
        [FILTERS_NAMES_CONST.SERVICE.FIELDS.CATEGORY.name]: async () => {
          await this.getListDataById(ID_LIST.SERVICE_CATEGORY);
        },
        [FILTERS_NAMES_CONST.SERVICE.FIELDS.CUPS.name]: async () => {
          await this.getCups();
        },
        [FILTERS_NAMES_CONST.SERVICE.FIELDS.TYPE.name]: async () => {
          this.getList(data.type, data.key);
        },
        [FILTERS_NAMES_CONST.SERVICE.FIELDS.STATUS.name]: async () => {
          this.getListDataByName(LIST_CONSTANTS.SERVICE_STATES_LIST_NAME);
        },
        [FILTERS_NAMES_CONST.ORDER.FIELDS.PRICE_LEVEL.name]: async () => {
          this.getPriceLevels();
        },
        [FILTERS_NAMES_CONST.SERVICE.FIELDS.SESSION_TEMPLATE
          .name]: async () => {
          await this.getAllSessionTemplates();
        },
        [FILTERS_NAMES_CONST.SERVICE.FIELDS.SESSION_STATE.name]: async () => {
          this.setList(SESION_STATUS_VALUES as List[]);
          const value = SESION_STATUS_VALUES.filter(
            e => e.key == this.valueToEdit[0]
          );
          this.selectField = value;
        }
      },
      [FILTERS_NAMES_CONST.FORM.NAME]: {
        [FILTERS_NAMES_CONST.FORM.FIELDS.FORMTEMPLATE.name]: async () => {
          await this.getFormTemplates();
        },
        [FILTERS_NAMES_CONST.FORM.FIELDS.OWNER.name]: async () => {
          await this.getUserByQuery(QUERY_USER_SERVICE.USER);
        },
        [FILTERS_NAMES_CONST.FORM.FIELDS.SERVICE.name]: async () => {
          await this.getServiceTemplates();
        },
        [FILTERS_NAMES_CONST.FORM.FIELDS.CATEGORY.name]: async () => {
          this.getList(data.type, data.key);
        }
      },
      [FILTERS_NAMES_CONST.USER.NAME]: {
        [FILTERS_NAMES_CONST.USER.FIELDS.ROLE.name]: async () => {
          await this.getRoleList();
        },
        [FILTERS_NAMES_CONST.USER.FIELDS.USERTEMPLATE.name]: async () => {
          await this.getUserTemplates();
        },
        [FILTERS_NAMES_CONST.USER.FIELDS.STATUS.name]: async () => {
          this.getListDataByName(LIST_CONSTANTS.USERS_STATES_LIST_NAME);
        },
        [FILTERS_NAMES_CONST.USER.FIELDS.DEPENDENCY.name]: async () => {
          await this.getDependenciesList();
        }
      },
      [FILTERS_NAMES_CONST.MEDICAL_APPOIMENT.NAME]: {
        [FILTERS_NAMES_CONST.MEDICAL_APPOIMENT.FIELDS.PATIENT
          .name]: async () => {
          await this.getUserByQuery(QUERY_USER_SERVICE.PATIENT);
        },
        [FILTERS_NAMES_CONST.MEDICAL_APPOIMENT.FIELDS.DOCTOR
          .name]: async () => {
          await this.getUserByQuery(QUERY_USER_SERVICE.DOCTOR);
        },
        [FILTERS_NAMES_CONST.MEDICAL_APPOIMENT.FIELDS.SERVICE
          .name]: async () => {
          await this.getServiceTemplates();
        },
        [FILTERS_NAMES_CONST.MEDICAL_APPOIMENT.FIELDS.STATE.name]: async () => {
          this.getMedicalAppointmentStateList();
        },
        [FILTERS_NAMES_CONST.MEDICAL_APPOIMENT.FIELDS.CAMPUS
          .name]: async () => {
          await this.getAllCampus();
        },
        [FILTERS_NAMES_CONST.MEDICAL_APPOIMENT.FIELDS.SPACE.name]: async () => {
          await this.getAllMedicalSpaces();
        }
      },
      [FILTERS_NAMES_CONST.SESSION.NAME]: {
        [FILTERS_NAMES_CONST.SESSION.FIELDS.SESSIONTEMPLATE.name]: async () => {
          await this.getAllSessionTemplates();
        },
        [FILTERS_NAMES_CONST.SESSION.FIELDS.OWNER.name]: async () => {
          await this.getUserByQuery(QUERY_USER_SERVICE.USER);
        },
        [FILTERS_NAMES_CONST.SESSION.FIELDS.SERVICE.name]: async () => {
          await this.getServiceTemplates();
        },
        [FILTERS_NAMES_CONST.SESSION.FIELDS.STATUS.name]: async () => {
          this.getList(data.type, data.key);
        }
      },
      [FILTERS_NAMES_CONST.TASK.NAME]: {
        [FILTERS_NAMES_CONST.TASK.FIELDS.ROLE.name]: async () => {
          await this.getRoleList();
        },
        [FILTERS_NAMES_CONST.TASK.FIELDS.STATUS.name]: async () => {
          this.getList(data.type, data.key);
        },
        [FILTERS_NAMES_CONST.TASK.FIELDS.DEPENDENCY.name]: async () => {
          await this.getDependenciesList();
        },
        [FILTERS_NAMES_CONST.TASK.FIELDS.FORMTEMPLATE.name]: async () => {
          await this.getFormTemplates();
        },
        [FILTERS_NAMES_CONST.TASK.FIELDS.PATIENT.name]: async () => {
          await this.getUserByQuery(QUERY_USER_SERVICE.USER);
        }
      },
      [FILTERS_NAMES_CONST.ORDER.NAME]: {
        [FILTERS_NAMES_CONST.ORDER.FIELDS.USER.name]: async () => {
          await this.getUserByQuery(QUERY_USER_SERVICE.USER);
        },
        [FILTERS_NAMES_CONST.ORDER.FIELDS.CAMPUS.name]: async () => {
          await this.getListDataById(ID_LIST.CAMPUS);
        },
        [FILTERS_NAMES_CONST.ORDER.FIELDS.CUPS.name]: async () => {
          await this.getCups();
        },
        [FILTERS_NAMES_CONST.ORDER.FIELDS.DIAGNOSIS_CODE.name]: async () => {
          await this.getListDataById(ID_LIST.DIAGNOSIS_CODE);
        },
        [FILTERS_NAMES_CONST.ORDER.FIELDS.STATUS.name]: async () => {
          this.getListDataByName(LIST_CONSTANTS.ORDER_STATES_LIST_NAME);
        },

        [FILTERS_NAMES_CONST.ORDER.FIELDS.PAYMENT_METHOD.name]: async () => {
          this.getList(data.type, data.key);
        },
        [FILTERS_NAMES_CONST.ORDER.FIELDS.PRICE_LEVEL.name]: async () => {
          this.getPriceLevels();
        },
        [FILTERS_NAMES_CONST.ORDER.FIELDS.ORDER_TYPE.name]: async () => {
          this.getList(data.type, data.key);
        }
      },
      [FILTERS_NAMES_CONST.LEAD.NAME]: {
        [FILTERS_NAMES_CONST.LEAD.FIELDS.TYPE.name]: async () => {
          this.getListDataByName(LIST_CONSTANTS.LEADS_TYPE_LIST_NAME);
        }
      }
    };
    const typeGetData = getData[data.type];
    const typeData =
      typeGetData !== undefined ? typeGetData[data.key] : undefined;

    if (typeData !== undefined) {
      await typeData();
    }
  }

  @Watch("groupsLevels")
  getGroupLevel() {
    if (
      this.collection === GENERAL_RULES_CONSTANTS.SERVICIO &&
      this.field === FILTERS_NAMES_CONST.SERVICE.FIELDS.GROUP_LEVEL.name
    ) {
      this.setList(JSON.parse(JSON.stringify(this.groupsLevels)));

      if (this.editCase && this.valueToEdit) {
        this.selectField = this.valueToEdit.map((value: string) => {
          return this.groupsLevels.find(
            item =>
              item.key === (typeof value === "string" ? value : value["key"])
          );
        });
      }
    }
  }

  getGroupLevelState() {
    this.setList(LEVELS_GROUPS_STATES);
    if (this.editCase && this.valueToEdit) {
      this.selectField = this.valueToEdit.map((value: string) => {
        return LEVELS_GROUPS_STATES.find(item => item.name === value);
      });
    }
  }

  async getDependenciesList() {
    try {
      const filter: QuerySendMultiple = {
        state: [GENERAL_RULES_CONSTANTS.ACTIVO]
      };

      const responseData = await this.dependenciesService.getDependenciesWithFilters(
        filter
      );
      if (responseData.code === Http.Found && responseData.data) {
        const depenednciesList: List[] = [];
        const dataList = responseData.data.data;
        dataList.forEach(dependency =>
          depenednciesList.push({ key: dependency.id!, name: dependency.name })
        );
        this.setList(depenednciesList);
        this.selectField = this.valueToEdit;
      } else {
        Snackbar.popInfo(LACK_OF_OPTIONS);
      }
    } catch (error) {
      if ((error as AxiosError).response?.status == Http.Forbidden)
        Snackbar.popError(
          FORM_MESSAGES.FORBIDDEN_REQUEST + DEPENDENCIES_ACCESS.GET
        );
      else Snackbar.popError(FORM_MESSAGES.REQUEST_FAILED);
    }
  }

  async getListDataById(id: string) {
    try {
      const responseData = await this.listService.getListById(id);
      if (responseData.code === Http.Found && responseData.data !== undefined) {
        const listDataList: List[] = [];
        const dataList = responseData.data.optionsSchema as {
          title: string;
        }[];
        dataList.forEach(a =>
          listDataList.push({ key: a.title, name: a.title })
        );
        this.setList(listDataList);
        this.selectField = this.valueToEdit;
      } else {
        Snackbar.popInfo(LACK_OF_OPTIONS);
      }
    } catch (error) {
      if ((error as AxiosError).response?.status == Http.Forbidden)
        Snackbar.popError(FORM_MESSAGES.FORBIDDEN_REQUEST + LIST_ACCESS.GET);
      else Snackbar.popError(FORM_MESSAGES.REQUEST_FAILED);
    }
  }

  async getAllCampus() {
    try {
      const response = await this.campusService.getAllCampus();
      if (response.code === Http.Found && response.data) {
        const campus = response.data;
        const campusList: List[] = [];

        campus.forEach(({ key, name }) => {
          campusList.push({ key, name });
        });
        this.setList(campusList);
        this.selectField = this.valueToEdit;
      } else {
        Snackbar.popInfo(LACK_OF_OPTIONS);
      }
    } catch (error) {
      if ((error as AxiosError).response?.status == Http.Forbidden)
        Snackbar.popError(FORM_MESSAGES.FORBIDDEN_REQUEST + LIST_ACCESS.GET);
      else Snackbar.popError(FORM_MESSAGES.REQUEST_FAILED);
    }
  }

  async getAllMedicalSpaces() {
    const filterQuery: SpaceQuery = {
      state: [STATE.ACTIVE]
    };

    try {
      const responseData = await this.spaceService.getAllSpacesWithFilters(
        filterQuery
      );

      if (responseData.code === Http.Found && responseData.data !== undefined) {
        const listDataList: List[] = [];
        const dataList = responseData.data;
        dataList.forEach(space =>
          listDataList.push({
            key: space._key!,
            name: `${space.name} - ${space.campusName || ""}`
          })
        );
        this.setList(listDataList);
        this.selectField = this.valueToEdit;
      } else {
        Snackbar.popInfo(LACK_OF_OPTIONS);
      }
    } catch (error) {
      if ((error as AxiosError).response?.status == Http.Forbidden)
        Snackbar.popError(FORM_MESSAGES.FORBIDDEN_REQUEST + LIST_ACCESS.GET);
      else Snackbar.popError(FORM_MESSAGES.REQUEST_FAILED);
    }
  }

  async getCups() {
    try {
      const responseData = await this.cupsPriceLevelService.getAllActiveCupsPriceLevel();
      if (responseData.code === Http.Found && responseData.data !== undefined) {
        const serviceCups = responseData.data;
        const serviceCupsList: List[] = [];
        serviceCups.forEach(cup => {
          serviceCupsList.push({
            key: cup.id,
            name: `${cup.cups} - ${cup.externalName}`
          });
        });
        this.$emit(
          GENERAL_RULES_CONSTANTS.EMITTERS.SET_CLIENTS_CUPS,
          serviceCups
        );
        this.setList(serviceCupsList);
        this.selectField = this.valueToEdit;
      } else {
        Snackbar.popInfo(LACK_OF_OPTIONS);
      }
    } catch (error) {
      if ((error as AxiosError).response?.status == Http.Forbidden)
        Snackbar.popError(FORM_MESSAGES.FORBIDDEN_REQUEST + CUPS_ACCESS.GET);
      else Snackbar.popError(FORM_MESSAGES.REQUEST_FAILED);
    }
  }

  async getAllSessionTemplates() {
    try {
      const response = await this.sessionTemplateService.getAllActiveSessionTemplates();
      if (response.code === Http.Found && response.data) {
        const sessionTemplate = response.data;
        let sessionTemplateList = [];
        const isGroupCondition = this.conditionsContext
          ? this.conditionsContext.find(
              (e: any) =>
                e.key == FILTERS_NAMES_CONST.SERVICE.FIELDS.GROUP_LEVEL.name
            )
          : false;
        const groupSelected = this.groupsLevels.find(
          e => e.key == isGroupCondition.value[0].key
        );
        if (isGroupCondition && groupSelected) {
          sessionTemplateList = sessionTemplate.filter(session =>
            groupSelected.sessions.includes(session.id)
          );
          sessionTemplateList = sessionTemplateList.map(temp => {
            return {
              key: temp.id as string,
              name: temp.name
            };
          });
        } else {
          sessionTemplateList = sessionTemplate.map(session => {
            return {
              key: session.id as string,
              name: session.name
            };
          });
        }
        this.setList(sessionTemplateList);
        this.selectField = sessionTemplateList.filter(
          e => e.key == this.valueToEdit[0]
        );
      } else {
        Snackbar.popInfo(response.message);
      }
    } catch (error) {
      if ((error as AxiosError).response?.status == Http.Forbidden)
        Snackbar.popError(
          FORM_MESSAGES.FORBIDDEN_REQUEST + SESSION_TEMPLATES_ACCESS.GET
        );
      else Snackbar.popError(FORM_MESSAGES.REQUEST_FAILED);
    }
  }

  async getFormTemplates() {
    try {
      const response = await this.formTemplateService.getFormTemplateWithFilters(
        { state: GENERAL_RULES_CONSTANTS.ACTIVO }
      );

      if (response.code === Http.Found && response.data) {
        this.lastRef = response.data.docref;
        const formTemplates = response.data;
        const formTemplatesList: List[] = [];
        formTemplates.data.forEach(({ _key, name }) => {
          formTemplatesList.push({
            key: _key as string,
            name
          });
        });

        const formTemplatesIds = formTemplatesList.map(item => item.key);
        const formTemplatesToEditInFormTemplatesList = this.valueToEdit.filter(
          (item: string) => !formTemplatesIds.includes(item)
        );

        if (formTemplatesToEditInFormTemplatesList.length > 0) {
          const formTemplates = await this.getFormTemplatesToEdit(
            formTemplatesToEditInFormTemplatesList
          );

          if (formTemplates) {
            formTemplates.forEach((formTemplate: FormStatus) => {
              formTemplatesList.push({
                key: formTemplate._key,
                name: formTemplate.name!
              });
            });
          }
        }

        this.setList(formTemplatesList);
        this.selectField = this.valueToEdit;
      } else {
        Snackbar.popInfo(response.message);
      }
    } catch (error) {
      if ((error as AxiosError).response?.status == Http.Forbidden)
        return Snackbar.popError(
          FORM_MESSAGES.FORBIDDEN_REQUEST + FORM_TEMPLATES_ACCESS.GET
        );
      else return Snackbar.popError(FORM_MESSAGES.REQUEST_FAILED);
    }
  }
  async getFormTemplatesToEdit(
    formTemplatesToEditInFormTemplatesList: string[]
  ) {
    try {
      const response = await this.formTemplateService.getFormTempsByIdsArray({
        formTempsId: formTemplatesToEditInFormTemplatesList
      });
      if (response.code === Http.Found && response.data) {
        return response.data;
      } else {
        Snackbar.popInfo(response.message);
      }
    } catch (error) {
      if ((error as AxiosError).response?.status == Http.Forbidden)
        return Snackbar.popError(
          FORM_MESSAGES.FORBIDDEN_REQUEST + ROLES_ACCESS.GET
        );
      else return Snackbar.popError(FORM_MESSAGES.REQUEST_FAILED);
    }
  }

  async getRoleList() {
    try {
      const response = await this.rolesService.getAllActiveRoles();

      if (response.code === Http.Found && response.data) {
        const rolesUser = response.data;
        const rolesUserList: List[] = [];
        rolesUser.forEach(({ id, name }) => {
          rolesUserList.push({ key: id, name });
        });
        if (this.editCase)
          this.value = rolesUserList.find(
            item => item.key === this.valueToEdit
          )?.name;
        this.selectField = this.value;
        this.setList(rolesUserList);
        this.selectField = this.valueToEdit;
      } else {
        Snackbar.popInfo(response.message);
      }
    } catch (error) {
      if ((error as AxiosError).response?.status == Http.Forbidden)
        return Snackbar.popError(
          FORM_MESSAGES.FORBIDDEN_REQUEST + ROLES_ACCESS.GET
        );
      else return Snackbar.popError(FORM_MESSAGES.REQUEST_FAILED);
    }
  }

  async getUserTemplates() {
    try {
      const response = await this.userTemplateService.getAllActiveUserTemplates();
      if (response.code === Http.Found && response.data) {
        const formTemplatesUser = response.data;
        const formTemplatesUserList: List[] = [];
        formTemplatesUser.forEach(({ _key, name }) => {
          formTemplatesUserList.push({ key: _key, name });
        });
        this.setList(formTemplatesUserList);
        this.selectField = this.valueToEdit;
      } else {
        Snackbar.popInfo(response.message);
      }
    } catch (error) {
      if ((error as AxiosError).response?.status == Http.Forbidden)
        return Snackbar.popError(
          FORM_MESSAGES.FORBIDDEN_REQUEST + USER_TEMPLATES_ACCESS.GET
        );
      else return Snackbar.popError(FORM_MESSAGES.REQUEST_FAILED);
    }
  }

  async getUserByQuery(query: UserQuery) {
    try {
      this.dependency = query.dependency
        ? typeof query.dependency == "string"
          ? [query.dependency]
          : query.dependency
        : [];
      const response = await this.userService.getUserByFilters(query);

      if (response.code !== Http.Found || !response.data) {
        Snackbar.popInfo(response.message);
        return;
      }
      this.lastRef = response.data.lastReference;
      const users = response.data.userArray;
      const userList: List[] = [];
      users.forEach(item => {
        userList.push({
          key: item.id,
          name:
            item.name && item.name != "" ? item.name : item.userDocument ?? ""
        });
      });

      if (this.valueToEdit) {
        const userListIds = userList.map(item => item.key);
        const userToEditInUserList = this.valueToEdit.filter(
          (item: string) => !userListIds.includes(item)
        );

        if (userToEditInUserList.length > 0) {
          const users = await this.getUserToEdit(userToEditInUserList);
          if (users) {
            users.forEach(user => {
              userList.push({ key: user.id, name: user.name! });
            });
          }
        }
      }
      this.setList(userList);
      this.selectField = this.valueToEdit;
    } catch (error) {
      if ((error as AxiosError).response?.status == Http.Forbidden)
        return Snackbar.popError(
          FORM_MESSAGES.FORBIDDEN_REQUEST + USER_ACCESS.GET
        );
      else return Snackbar.popError(FORM_MESSAGES.REQUEST_FAILED);
    }
  }
  async getUserToEdit(userIds: string[]) {
    try {
      const response = await this.userService.getUsersByIdsArray({
        usersId: userIds
      });

      if (response.code !== Http.Found || !response.data) {
        Snackbar.popInfo(response.message);
        return undefined;
      }

      return response.data;
    } catch (error) {
      if ((error as AxiosError).response?.status == Http.Forbidden) {
        Snackbar.popError(FORM_MESSAGES.FORBIDDEN_REQUEST + USER_ACCESS.GET);
        return undefined;
      } else {
        Snackbar.popError(FORM_MESSAGES.REQUEST_FAILED);
        return undefined;
      }
    }
  }

  @Watch("value")
  changeValue() {
    this.$emit(GENERAL_RULES_CONSTANTS.EMITTERS.SEND_VALUE, {
      value: [this.value],
      index: this.index,
      timeUnit: this.timeUnit,
      status: this.status
    });
    this.status = true;
  }

  deleteGroup(index: number) {
    if (Array.isArray(this.value)) {
      this.value.splice(index, 1);
      return;
    }
    this.value = "";
  }

  preloadInput() {
    if (this.list.length > 0 && this.valueToEdit !== undefined) {
      if (Array.isArray(this.valueToEdit)) {
        const valuesMaped = this.valueToEdit.map((element: any) => {
          const findValue: any = this.list.find(item => {
            if (Object.keys(element).includes(GENERAL_RULES_CONSTANTS.KEY)) {
              return item.key === element.key;
            }
            return item.key === element;
          });
          return findValue !== undefined ? findValue : { key: "", name: "" };
        });
        if (
          this.operator === GENERAL_RULES_CONSTANTS.INCLUDE_OPERATOR ||
          this.operator === GENERAL_RULES_CONSTANTS.BELONGS_OPERATOR
        ) {
          this.value = valuesMaped;
          return;
        }
        this.value = valuesMaped[0];
      }
    }
  }

  saveDate(date: string | string[]) {
    if (Array.isArray(date)) {
      if (date.length === 1) {
        Snackbar.popError(GENERAL_RULES_CONSTANTS.MESSAGES.MUST_BE_RANGE);
        return;
      }

      const date1 = new Date(date[0]).getTime();
      const date2 = new Date(date[1]).getTime();

      if (date1 > date2) {
        date = [date[1], date[0]];
      }
    }
    this.value = date;
    this.menu = false;
    this.date = date;
  }

  getList(type: string, key: string) {
    const dropdownServices: Collection[] = lodash.cloneDeep(
      GENERAL_RULES_CONSTANTS.DROPDOWN_SERVICES
    );
    const collection = dropdownServices.find(item => item.name === type);
    const field = collection?.fields.find(
      (item: GenaralRuleField) => item.field === key
    );
    this.setList(field?.value as List[]);
    this.selectField = this.valueToEdit;
  }

  getPriceLevels() {
    if (this.cupsSelected[0] !== undefined && this.cupsSelected !== undefined) {
      let finalListPriceLevels: List[] = [];

      this.cupsSelected.forEach((item: List) => {
        const findCup = this.cups.find(
          (element: any) => element.id === item.key
        );
        if (findCup !== undefined) {
          const priceLevelList: any[] = [];
          for (const property in findCup.clients) {
            const priceLevel = { key: "", name: "" };
            priceLevel.key = property;
            priceLevel.name = `${findCup.clients[property].name}-${findCup.clients[property].price}`;
            priceLevelList.push(priceLevel);
          }
          finalListPriceLevels = [...finalListPriceLevels, ...priceLevelList];
        }
      });

      this.setList(finalListPriceLevels);
      this.selectField = this.valueToEdit;
    }
  }

  @Watch("cupsSelected")
  listenCupsListToPriceLevels() {
    if (this.field === PRICE_LEVEL) {
      this.getPriceLevels();
    }
  }

  @Watch("UsersListEnable")
  listenUserList() {
    if (this.UsersListEnable!.length > 0) {
      if (
        this.userList!.length > 0 &&
        this.UsersListEnable.find((item: any) => item === this.index) !==
          undefined
      ) {
        this.setList(this.userList![+this.index]);
      }
    }
  }

  selectIsMultiple() {
    if (
      this.operator == GENERAL_RULES_CONSTANTS.INCLUDE_OPERATOR ||
      this.operator == GENERAL_RULES_CONSTANTS.BELONGS_OPERATOR
    )
      return true;
    else return false;
  }

  setTimeUnit(timeUnit: { label: string; value: string }) {
    this.timeUnit = timeUnit.value;
    this.$emit("updateTimeUnit", this.timeUnit);
  }

  async getMedicalAppointmentStateList() {
    try {
      const response = await this.listService.getAppointmentStatus();
      if (response.code === Http.Found && response.data) {
        const appoitmentStateList = response.data;
        const StateList: List[] = [];
        appoitmentStateList.options.forEach(({ value, title }) => {
          StateList.push({
            key: value as string,
            name: title
          });
        });
        this.setList(StateList);
        this.selectField = this.valueToEdit;
      } else {
        Snackbar.popInfo(response.message);
      }
    } catch (error) {
      if ((error as AxiosError).response?.status == Http.Forbidden)
        Snackbar.popError(FORM_MESSAGES.FORBIDDEN_REQUEST + LIST_ACCESS.GET);
      else Snackbar.popError(FORM_MESSAGES.REQUEST_FAILED);
    }
  }

  loadItems(name?: string) {
    if (!name) {
      this.keyword = "";
      this.lasRefWithNameFilter = "";
    }
    switch (this.field) {
      case FILTERS_NAMES_CONST.FORM.FIELDS.OWNER.name:
        this.findUsers(name);
        break;
      case FILTERS_NAMES_CONST.MEDICAL_APPOIMENT.FIELDS.PATIENT.name:
        this.findUsers(name);
        break;
      case FILTERS_NAMES_CONST.ORDER.FIELDS.USER.name:
        this.findUsers(name);
        break;
      case FILTERS_NAMES_CONST.MEDICAL_APPOIMENT.FIELDS.DOCTOR.name:
        this.findUsers(name);
        break;
      case FILTERS_NAMES_CONST.FORM.FIELDS.FORMTEMPLATE.name:
        this.findFormTemplates(name);
        break;
      case FILTERS_NAMES_CONST.TASK.FIELDS.FORMTEMPLATE.name:
        this.findFormTemplates(name);
        break;
      default:
        break;
    }
  }
  async findFormTemplates(name?: string) {
    try {
      const filterQuery = this.setFilters(
        GENERAL_RULES_CONSTANTS.DOC_REF,
        name
      );

      const responseFormTemplates = await this.formTemplateService.getFormTemplateWithFilters(
        filterQuery as QuerySend
      );

      if (responseFormTemplates.code === Http.Found) {
        this.setListsOfTheDifferentsFields(
          responseFormTemplates.data?.data,
          responseFormTemplates.data?.docref!,
          GENERAL_RULES_CONSTANTS._KEY,
          filterQuery.name
        );
        return;
      }
    } catch (error) {
      const errorMessage =
        (error as Error).message === GENERAL_CONSTANTS.FORBIDDEN
          ? `${FORM_MESSAGES.FORBIDDEN_REQUEST}${USER_ACCESS.GET}`
          : FORM_MESSAGES.REQUEST_FAILED;

      Snackbar.popError(errorMessage);
    }
  }

  async findUsers(name?: string) {
    try {
      const filterQuery = this.setFilters(
        GENERAL_RULES_CONSTANTS.ID_REFERENCE,
        name
      );

      if (this.collection === FILTERS_NAMES_CONST.TASK.NAME) {
        const conditionDependency = this.conditionsContext?.find(
          (item: any) =>
            item.key === FILTERS_NAMES_CONST.TASK.FIELDS.DEPENDENCY.name
        );
        if (conditionDependency) {
          this.dependency = conditionDependency.value
            .map((item: any) => item.name)
            .filter(String);
        }
      }

      if (this.dependency.length > 0) {
        filterQuery.dependency = this.dependency;
      }

      const responseUsers = await this.userService.getUserByFilters(
        filterQuery as UserQuery
      );

      if (responseUsers.code === Http.Found) {
        this.setListsOfTheDifferentsFields(
          responseUsers.data?.userArray,
          responseUsers.data?.lastReference!,
          GENERAL_RULES_CONSTANTS.ID,
          filterQuery.name
        );
        return;
      }
    } catch (error) {
      const errorMessage =
        (error as Error).message === GENERAL_CONSTANTS.FORBIDDEN
          ? `${FORM_MESSAGES.FORBIDDEN_REQUEST}${USER_ACCESS.GET}`
          : FORM_MESSAGES.REQUEST_FAILED;

      Snackbar.popError(errorMessage);
    }
  }

  setListsOfTheDifferentsFields(
    responseData: any,
    lastReference: string,
    fielToFindId: string,
    queryName: string
  ) {
    const items = responseData.map((item: any) => ({
      id: item[fielToFindId],
      name: item.name || item.userName
    })) as [{ id: string; name: string }];

    this.FieldSelectConfig.listAll = [
      ...this.FieldSelectConfig.listAll,
      ...items
    ];

    if (!queryName) {
      this.lastRef = lastReference;
    }
    this.lasRefWithNameFilter = queryName ? lastReference : "";
    this.FieldSelectConfig.loadingData = false;
  }

  setFilters(keyLastRef: string, name?: string) {
    const filterQuery: any = {
      state: GENERAL_RULES_CONSTANTS.ACTIVO
    };

    if (name && this.keyword !== name) {
      this.keyword = name!;
      delete filterQuery[keyLastRef];
    }

    if (this.lasRefWithNameFilter) {
      filterQuery[keyLastRef] = this.lasRefWithNameFilter;
    } else {
      filterQuery[keyLastRef] = this.lastRef;
    }

    if (name) {
      filterQuery.name = name;
    }

    return filterQuery;
  }

  async getListDataByName(name: string) {
    try {
      const responseData = await this.listService.getListOptionsByName(name);
      if (responseData.code === Http.Found && responseData.data !== undefined) {
        const listDataList: List[] = [];
        const dataList = responseData.data;
        dataList.forEach(a =>
          listDataList.push({ key: (a.id || a.value) as string, name: a.title })
        );
        this.setList(listDataList);
        this.selectField = this.valueToEdit;
      } else {
        Snackbar.popInfo(LACK_OF_OPTIONS);
      }
    } catch (error) {
      if ((error as AxiosError).response?.status == Http.Forbidden)
        Snackbar.popError(FORM_MESSAGES.FORBIDDEN_REQUEST + LIST_ACCESS.GET);
      else Snackbar.popError(FORM_MESSAGES.REQUEST_FAILED);
    }
  }
}
